import { render, staticRenderFns } from "./DashboardManager.vue?vue&type=template&id=349d138e&scoped=true&"
import script from "./DashboardManager.vue?vue&type=script&lang=js&"
export * from "./DashboardManager.vue?vue&type=script&lang=js&"
import style0 from "./DashboardManager.vue?vue&type=style&index=0&id=349d138e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "349d138e",
  null
  
)

export default component.exports